import React, { useEffect } from "react";
import { Input, Skeleton, Table } from "antd";
import TableTitle from "../../../../../common/TableTitle";
import FormLabel from "../../../../../common/Form/FormLabel";

const DecisionMaintienRefus = ({
  mission,
  questions,
  loading,
  acceptLoading,
  questionsData,
  setQuestionData,
  setConclusion,
  conclusion,
  affectValid,
  isDecisionSaved,
}) => {
  // ✅ Corriger l'initialisation des données
  useEffect(() => {
    // ✅ Ne pas écraser les données existantes, seulement initialiser si vide
    if (!questionsData || questionsData.length === 0) {
      const quests = questions.map((question, index) => ({
        question_id: question.id,
        libelle: question.libelle,
        isCheckedN: false,
        isCheckedN_1: false,
        motifRequired: true,
        motif: "", // ✅ Utiliser "motif" au lieu de "commentaire"
      }));
      setQuestionData(quests);
    }
  }, [questions, questionsData, setQuestionData]);

  // ✅ Corriger la fonction de mise à jour des commentaires
  const handleCommentChange = (index, motif) => {
    console.log(`Mise à jour commentaire ${index}:`, motif); // ✅ Debug

    const updatedList = questionsData.map((item, i) =>
      i === index
        ? {
            ...item,
            motif: motif, // ✅ Utiliser "motif" au lieu de "commentaire"
            motifRequired: !item.isCheckedN && (!motif || motif.trim() === ""),
          }
        : item
    );

    console.log("Données mises à jour:", updatedList); // ✅ Debug
    setQuestionData(updatedList);
  };

  const columns = [
    {
      title: () => <TableTitle>Questions</TableTitle>,
      dataIndex: "name",
      width: 500,
      render: (_, record) => (
        <>
          <Input.TextArea
            size="large"
            value={record.libelle}
            readOnly={true}
            bordered={false}
            style={{ width: "100%" }}
            autoSize={{
              minRows: 2,
              maxRows: 10,
            }}
          />
        </>
      ),
    },
    {
      title: () => <TableTitle>Commentaire</TableTitle>,
      dataIndex: "commentaire",
      width: 500,
      render: (_, record, index) => {
        console.log(`Render commentaire ${index}:`, record); // ✅ Debug

        return (
          <>
            <Input.TextArea
              size="large"
              placeholder="Saisissez le commentaire"
              value={record.motif || ""} // ✅ Utiliser "motif" au lieu de "commentaire"
              readOnly={
                mission.isCloture === 1 ||
                mission.isClotureProvisoire === 1 ||
                (affectValid && affectValid !== false) || // ✅ Vérification explicite
                (isDecisionSaved && isDecisionSaved !== false) // ✅ Vérification explicite
              }
              onChange={(e) => {
                console.log(`Changement dans ${index}:`, e.target.value); // ✅ Debug
                handleCommentChange(index, e.target.value);
              }}
              bordered={true} // ✅ Activer les bordures pour voir le champ
              style={{
                width: "100%",
                backgroundColor: "white", // ✅ S'assurer que le fond est visible
              }}
              showCount
              maxLength={5000}
              autoSize={{
                minRows: 2,
                maxRows: 8,
              }}
            />
          </>
        );
      },
    },
  ];

  return (
    <>
      {acceptLoading ? (
        <Skeleton active />
      ) : (
        <div className="">
          <p className="fs-5 fw-semibold text-gray-600 py-6">
            Si le client n'a pas été accepté, ce document doit être conservé par
            l'associé (ou autre réviseur d'entreprises) responsable de la
            mission. <br />
            Le contenu de ce document doit d'abord être revu avant communication
            à des tiers. <br />
            <br />
            Il se peut toutefois que des événements ultérieurs viennent modifier
            les fondements de cette nomination. Un réexamen de la situation et
            une nouvelle consultation s'imposeront alors et donneront lieu à une
            nouvelle conclusion, adaptée le cas échéant. <br />
            La checklist ci-dessous pourra être utilisée dans une telle
            situation.
          </p>

          <div className="table-responsive mb-2">
            <Table
              loading={loading}
              columns={columns}
              dataSource={questionsData}
              pagination={false}
              scroll={{ y: 500 }}
              bordered={true} // ✅ Activer les bordures
              size={"small"}
              rowKey={(record, index) => `refus-${record.question_id || index}`} // ✅ Clé unique
            />
          </div>

          <div className="d-flex flex-column my-7">
            <FormLabel required label="Conclusion :" />
            <Input.TextArea
              size="large"
              placeholder="Saisissez la conclusion"
              value={conclusion}
              readOnly={
                mission.isCloture === 1 ||
                mission.isClotureProvisoire === 1 ||
                (affectValid && affectValid !== false) ||
                (isDecisionSaved && isDecisionSaved !== false)
              }
              onChange={(e) => {
                setConclusion(e.target.value);
              }}
              style={{ width: "100%" }}
              showCount
              maxLength={5000}
              autoSize={{
                minRows: 7,
                maxRows: 10,
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default DecisionMaintienRefus;
